import { Button } from "components/Button/Button";
import IconButton from "components/Button/IconButton";
import Link from "components/Button/Link";
import NotFound from "components/not-found/NotFound";
import useFullPageLoader from "hooks/useFullPageLoader";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import toast from "react-hot-toast";
import Pagination from "react-js-pagination";
import { balancepaymentdateFormat } from "utils";
import * as XLSX from "xlsx";
import EditIcon from "@mui/icons-material/Edit";
import ModalBox from "components/modal/ModalBox";
import { Input, TextArea } from "components/Form";
import {
  getBalancePaymentBySearch,
  updateBalancePayment,
} from "services/lecture/lectureController";

export default function UpdateBalancePayment() {
  const [search, setSearch] = useState("");
  const [record, setRecord] = useState([]);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const [flag, setFlag] = useState(false);
  const [data, setData] = useState({});
  const [errorField, setErrorField] = useState({});
  const [updateModal, setUpdateModal] = useState(false);

  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();
  const [submitButtonElement1, setSubmitLoading1] = useMuiButtonLoader();

  //********************************************************* Fetch Records ********************************************************* */
  const fetchRecords = async () => {
    showLoader();
    try {
      const res = await getBalancePaymentBySearch({
        search: search,
        page: activePage,
        limit: limit,
      });

      if (res.code === 200) {
        const { count, rows } = res.data.balancepaymentlist;
        setRecord(rows || []);
        setTotal(count || 0);
        hideLoader();
        setFlag(true);
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
  };

  //   *************************** Handle Validation **************************************

  const HandleValidation = () => {
    const errors = {};

    if (!data.amount) {
      errors.amount = "Please Enter New Balance Amount";
    }

    setErrorField(errors);

    return Object.keys(errors).length === 0; // Return true if no errors
  };

  //********************************************************* Update Handler ********************************************************* */
  const updateHandler = async () => {
    try {
      setSubmitLoading1(true);
      if (HandleValidation()) {
        const res = await updateBalancePayment({
          admissionid: data.id,
          previousamount: data.BalancePayment,
          balanceamount: data.amount,
          comment: data.comment,
        });
        if (res.code === 200) {
          toast.success(res.message);
          fetchRecords();
          setUpdateModal(false);
        } else {
          toast.error(res.message);
          fetchRecords();
          setUpdateModal(false);
        }
      }
      setSubmitLoading1(false);
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
  };

  useEffect(() => {
    if (search) {
      fetchRecords();
    }
  }, [activePage, limit]);

  return (
    <>
      <div className="">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="search_wrap">
              <div className="search_wrap"></div>
              <h4 className="Title">Update Balance Payment</h4>
            </div>
            <div className=" mt-3">
              <div className="row w-100">
                <div className={`col-form-label py-0 col-sm-6`}>
                  <input
                    type="text"
                    placeholder="Enter Email/ Mobile"
                    className="form-control"
                    name="search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>

                <div className="col-sm-1 mx-4">
                  <Button onClick={fetchRecords} {...submitButtonElement}>
                    Search
                  </Button>
                </div>
              </div>
            </div>
            {loader}
            {flag && (
              <>
                <hr className="border border-danger" />
                <div className="TableList overflow-auto table-responsive">
                  <Table bordered className="table">
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Action</th>
                        <th>Payment Date</th>
                        <th>Balance Amount</th>
                        <th>Course Fees</th>
                        <th>Course Name</th>
                        <th>Student Name</th>
                        <th>EmailID</th>
                        <th>Mobile</th>
                        <th>Admission Status</th>
                        <th>Affiliate Name</th>
                      </tr>
                    </thead>
                    <tbody>
                      {record && record.length > 0 ? (
                        record.map((data, i) => {
                          let invoiceNo = "";
                          const currentYear = new Date().getFullYear();

                          if (data.AdmissionType === "Online") {
                            invoiceNo = `W-DL-${data.FinancialYear}-${
                              data.InvoiceNo || ""
                            }`;
                          } else if (
                            data.AdmissionType === "Offline" &&
                            data.PaymentType === "Bank"
                          ) {
                            invoiceNo = `B-DL-${data.FinancialYear}-${
                              data.InvoiceNo || ""
                            }`;
                          } else if (data.AdmissionType === "Offline") {
                            invoiceNo = `P-DL-${data.FinancialYear}-${
                              data.InvoiceNo || ""
                            }`;
                          }

                          // const displayPaymentType = data.AdmissionType === "Online" ? "Online" : data.PType;

                          return (
                            <tr key={i}>
                              <td>{++i + (activePage - 1) * limit}</td>

                              <td>
                                <div className="d-flex justify-content-center">
                                  <Link
                                    className="m-0"
                                    onClick={() => {
                                      setData({
                                        ...data,
                                        id: data.AdmissionID,
                                        BalancePayment: data.BalancePayment,
                                      });
                                      setUpdateModal(true);
                                    }}
                                  >
                                    <IconButton
                                      aria-label="view"
                                      className="px-2 py-0"
                                    >
                                      <EditIcon sx={{ color: "#4971B2" }} />
                                    </IconButton>
                                  </Link>
                                </div>
                              </td>
                              <td>
                                {balancepaymentdateFormat(data.BalancePayDate)}
                              </td>
                              <td>{data.BalancePayment}</td>
                              <td>{data.CourseFees}</td>
                              <td>{data.CourseName}</td>
                              <td>
                                {data.StudentName
                                  ? data.StudentName
                                  : `${data.StudentDetails?.FirstName} ${data.StudentDetails?.LastName}`}
                              </td>
                              <td>
                                {data.EmailID
                                  ? data.EmailID
                                  : `${data.StudentDetails?.EmailID}`}
                              </td>
                              <td>
                                {data.Mobile
                                  ? data.Mobile
                                  : `${data.StudentDetails?.Mobile}`}
                              </td>
                              <td>{data.AdmissionStatus}</td>
                              <td>{data.AffiliateName}</td>
                            </tr>
                          );
                        })
                      ) : (
                        <NotFound cols={12} />
                      )}
                    </tbody>
                  </Table>
                </div>
                {total > limit ? (
                  <div className="Pagination">
                    <Pagination
                      activePage={activePage}
                      previousLabel={"previous"}
                      nextLabel={"next"}
                      itemsCountPerPage={limit}
                      totalItemsCount={total}
                      pageRangeDisplayed={5}
                      onChange={(page) => setActivePage(page)}
                    />
                  </div>
                ) : null}
              </>
            )}
          </div>
        </div>
      </div>

      {/********************************************** Update Modal *********************************************************/}
      <ModalBox
        status={updateModal}
        onClose={() => setUpdateModal(false)}
        title={"Update Balance"}
        description={
          <>
            {" "}
            <div className="row mt-1">
              <div className="col-12 col-sm-12 col-md-12 col-lg-11 col-xl-11 mx-auto">
                <div className="form-group row mt-1">
                  <div className="col-sm-12 col-form-label order-1 d-flex flex-column justify-content-end">
                    <div className="row">
                      <div className="col-sm-12 col-form-label">
                        <div className="TableList overflow-auto table-responsive">
                          <Table bordered className="table">
                            {/* <tbody> */}
                            <tr>
                              <td style={{ border: "1px solid #ccc" }}>
                                Old Balance Amount
                              </td>
                              <td style={{ border: "1px solid #ccc" }}>
                                {data.BalancePayment}
                              </td>
                            </tr>
                            {/* </tbody> */}
                          </Table>
                        </div>
                      </div>
                      <div className="col-sm-12 col-form-label">
                        <Input
                          value={data.amount}
                          name="amount"
                          onChange={(e) => {
                            const { name, value } = e.target;
                            setData({
                              ...data,
                              [name]: value.replace(/\D/g, ""),
                            });
                          }}
                          className={"form-control"}
                          label={"New Balance Amount"}
                          placeholder={"Enter New Balance Amount"}
                          error={errorField.amount}
                          required // required
                        />
                      </div>
                      <div className="col-sm-12 col-form-label">
                        <TextArea
                          type="text"
                          name="comment"
                          placeholder="Enter Comment"
                          className={`form-control `}
                          maxLength={500}
                          rows={5}
                          value={data.comment}
                          label={"Comment"}
                          onChange={(e) => {
                            const { name, value } = e.target;
                            setData({
                              ...data,
                              [name]: value,
                            });
                          }}
                          // error={errorField.metadesc}
                          // required
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        }
        custom
        size={"sm"}
        customizedFooter={
          <>
            <Button
              onClick={() => {
                setUpdateModal(false);
                setData({});
                setErrorField({});
              }}
              {...submitButtonElement}
            >
              Cancel
            </Button>
            <Button onClick={updateHandler} {...submitButtonElement}>
              Update
            </Button>
          </>
        }
      />
    </>
  );
}
